// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer-container {
  margin-bottom: 0.5rem;
}

.custom-bonus-box {
  margin-top: 5px;
  border: 1px solid #dddddd;
}
.custom-bonus-box ion-input {
  background-color: var(--ion-color-light-tint);
  border-color: #ebebeb;
}
.custom-bonus-box ion-button {
  height: 40px;
  width: 90px;
}
.custom-bonus-box .wrapper {
  min-height: 90px;
}

.info-icon {
  color: #6cdd00;
}

.promo-code {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.promo-code .left {
  width: 50%;
}
.promo-code .right {
  width: 50%;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.promo-code .right ion-icon {
  padding: 0 10px;
  font-size: 1.6rem;
}

ion-checkbox {
  margin-top: 15px;
}

.info-icon:hover {
  cursor: pointer;
}

.message-box {
  display: none;
  margin: 0 !important;
  border: 1px solid #808080 !important;
  border-style: solid !important;
}

.message-box-visible {
  display: block;
  z-index: 1;
  border: 1px solid grey !important;
  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03), 0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03), 0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05), 0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
}

ion-checkbox {
  --border-color: var(--ion-color-dark);
  --checkbox-background: var(--ion-color-light);
  --checkbox-background-checked: #6CDD00;
  --checkmark-color: var(--ion-color-dark);
}

ion-checkbox.danger-checkbox {
  --checkbox-background-checked: var(--ion-color-danger)!important;
  --checkmark-color: var(--ion-color-light)!important;
}

.close-button {
  margin-top: -4.5%;
  margin-right: -2.5%;
}
@media screen and (max-width: 430px) {
  .close-button {
    margin-top: -11%;
  }
}
@media screen and (max-width: 353px) {
  .close-button {
    margin-top: -20%;
  }
}
@media screen and (max-width: 295px) {
  .close-button {
    margin-top: -31%;
  }
}
@media screen and (max-width: 245px) {
  .close-button {
    margin-top: -58%;
  }
}

.dial-one-plus {
  margin-right: 8px;
}

.phone-input-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.country-code {
  padding: 12px;
  font-size: 16px;
  border-left: 1px solid #C2C2C2;
  border-top: 1px solid #C2C2C2;
  border-bottom: 1px solid #C2C2C2;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

ion-icon[name*=information-circle] {
  font-size: 1.25rem;
  transform: translateY(0.25rem);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/signup-step-one/signup-step-one.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAEA;EACI,eAAA;EACA,yBAAA;AACJ;AACI;EACI,6CAAA;EACA,qBAAA;AACR;AAEI;EAEI,YAAA;EACA,WAAA;AADR;AAII;EACI,gBAAA;AAFR;;AAMA;EACE,cAAA;AAHF;;AAMA;EACI,aAAA;EAEA,WAAA;EACA,8BAAA;EACA,mBAAA;AAJJ;AAMI;EACI,UAAA;AAJR;AAOI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AALR;AAOQ;EACI,eAAA;EACA,iBAAA;AALZ;;AAWA;EACI,gBAAA;AARJ;;AAWA;EACI,eAAA;AARJ;;AAWA;EACI,aAAA;EACA,oBAAA;EACA,oCAAA;EACA,8BAAA;AARJ;;AAWA;EACI,cAAA;EACA,UAAA;EACA,iCAAA;EACA,iLAAA;EAIA,iBAAA;EACA,WAAA;EACA,gBAAA;AAXJ;;AAeA;EACI,qCAAA;EACA,6CAAA;EACA,sCAAA;EACA,wCAAA;AAZJ;;AAgBA;EACI,gEAAA;EACA,mDAAA;AAbJ;;AAgBA;EACI,iBAAA;EACA,mBAAA;AAbJ;AAeI;EAJJ;IAKQ,gBAAA;EAZN;AACF;AAcI;EARJ;IASQ,gBAAA;EAXN;AACF;AAaI;EAZJ;IAaQ,gBAAA;EAVN;AACF;AAYI;EAhBJ;IAiBQ,gBAAA;EATN;AACF;;AAYA;EACI,iBAAA;AATJ;;AAaA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAVJ;;AAaA;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EACA,2BAAA;EACA,8BAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,8BAAA;AAVJ","sourcesContent":[".offer-container {\n    margin-bottom: .5rem;\n}\n\n.custom-bonus-box {\n    margin-top: 5px;\n    border: 1px solid #dddddd;\n\n    ion-input {\n        background-color: var(--ion-color-light-tint);\n        border-color: #ebebeb;\n    }\n\n    ion-button {\n        // transform: translate(0, 27px);\n        height: 40px;\n        width: 90px;\n    }\n\n    .wrapper {\n        min-height: 90px;\n    }\n}\n\n.info-icon {\n  color: #6cdd00;\n}\n\n.promo-code {\n    display: flex;\n\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n\n    .left {\n        width: 50%;\n    }\n\n    .right {\n        width: 50%;\n        display: flex;\n        align-items: center;\n        padding-left: 10px;\n\n        ion-icon {\n            padding: 0 10px;\n            font-size: 1.6rem;\n            // transform: translate(0px, 35px);\n        }\n    }\n}\n\nion-checkbox {\n    margin-top: 15px;\n}\n\n.info-icon:hover {\n    cursor: pointer;\n}\n\n.message-box {\n    display: none;\n    margin: 0 !important;\n    border: 1px solid #808080 !important;\n    border-style: solid !important;\n}\n\n.message-box-visible {\n    display: block;\n    z-index: 1;\n    border: 1px solid grey !important;\n    box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03),\n        0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03),\n        0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05),\n        0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);\n    font-size: 1.2rem;\n    color: #333;\n    font-weight: 500;\n}\n\n\nion-checkbox {\n    --border-color: var(--ion-color-dark);\n    --checkbox-background: var(--ion-color-light);\n    --checkbox-background-checked: #6CDD00;\n    --checkmark-color: var(--ion-color-dark);\n\n}\n\nion-checkbox.danger-checkbox {\n    --checkbox-background-checked: var(--ion-color-danger)!important;\n    --checkmark-color: var(--ion-color-light)!important;\n}\n\n.close-button {\n    margin-top: -4.5%;\n    margin-right: -2.5%;\n\n    @media screen and (max-width: 430px) {\n        margin-top: -11%;\n    }\n\n    @media screen and (max-width: 353px) {\n        margin-top: -20%;\n    }\n\n    @media screen and (max-width: 295px) {\n        margin-top: -31%;\n    }\n\n    @media screen and (max-width: 245px) {\n        margin-top: -58%;\n    }\n}\n\n.dial-one-plus {\n    margin-right: 8px;\n}\n\n\n.phone-input-container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.country-code {\n    padding: 12px;\n    font-size: 16px;\n    border-left: 1px solid #C2C2C2;\n    border-top: 1px solid #C2C2C2;\n    border-bottom: 1px solid #C2C2C2;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\nion-icon[name*='information-circle'] {\n    font-size: 1.25rem;\n    transform: translateY(.25rem);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
